import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import { checkItem } from "./FilterCheckItem";
import { CustomComponentProps } from "utils/types/general.types";

export type FilterSearchCheckItem = CustomComponentProps & {
    title: string;
    val: string;
    setVal: React.Dispatch<React.SetStateAction<string>>;
    toggleItem: Function;
    items: checkItem[];
};
const FilterSearchCheckItem = ({
    title,
    val,
    setVal,
    toggleItem,
    items,
    className,
    style
}: FilterSearchCheckItem) => {
    return (
        <div
            className={`flex flex-col gap-3 px-4 py-2 my-2 mx-4 rounded bg-neutral-50 dark:bg-momeento-100 ${className}`}
            style={style}
        >
            <h3 className="font-medium dark:text-white">{title}</h3>
            <TextField
                id="search-user"
                name="search-user"
                label="Search"
                variant="outlined"
                size="small"
                sx={{ width: "100%" }}
                value={val}
                onChange={(e) => setVal(e.target.value)}
            />
            <div
                className="w-full flex flex-col items-start justify-start filter-items-container overflow-auto rounded bg-neutral-100 dark:bg-momeento-300 px-2 py-2"
                style={{ maxHeight: "40vh" }}
            >
                {items.map((i) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={i.checked}
                                onChange={() => toggleItem(i)}
                                size="small"
                            />
                        }
                        className="dark:text-white my-text-sm"
                        label={i.label}
                        key={i.label}
                    />
                ))}
            </div>
        </div>
    );
};
export default FilterSearchCheckItem;
